<template>
  <div class="c-stats-header">
    <div class="c-stats-header__row">
      <div
        class="c-stats-header__patient"
        v-if="!hidePatientDetails"
      >
        <eva-icon
          class="c-stats-header__patient-icon"
          name="person-outline"
        />
        {{ studyId }}
      </div>
      <div
        class="c-stats-header__stats"
        v-if="$vuetify.breakpoint.mdAndUp"
      >
        <stats-row
          :blood-pressure="bloodPressure"
          :weight="weight"
          :cholesterolLDL="cholesterolLDL"
          :cholesterol-l-d-l-unit="cholesterolLDLUnit"
          :glucose="glucose"
          :glucose-unit="glucoseUnit"
          :knowledge-level-name="knowledgeLevelName"
          :behaviour-goals="behaviourGoals"
          :outcome-goals="outcomeGoals"
          :bmi="bmi"
          :bmi-date="bmiDate"
        ></stats-row>
      </div>
      <div class="c-stats-header__controls">
        <slot name="button"></slot>
        <v-btn
          v-if="$vuetify.breakpoint.smAndDown"
          outlined
          icon
          color="primary"
          @click.prevent="showPatientStatsMobile = !showPatientStatsMobile"
          class="c-stats-header__mobile-stats-btn"
        >
          <v-icon :color="$color.coro.purple">mdi-arrow-expand</v-icon>
        </v-btn>
      </div>
    </div>
    <div
      class="c-stats-header__row"
      v-if="$vuetify.breakpoint.smAndDown && showPatientStatsMobile"
    >
      <stats-row
        :blood-pressure="bloodPressure"
        :weight="weight"
        :cholesterolLDL="cholesterolLDL"
        :glucose="glucose"
        :knowledge-level-name="knowledgeLevelName"
        :behaviour-goals="behaviourGoals"
        :outcome-goals="outcomeGoals"
        :bmi="bmi"
        :bmi-date="bmiDate"
      ></stats-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import StatsRow from "./StatsRow";
import Inventory from 'dashboard/store/patient-summary/inventory';

/**
 * Component StatsHeader.vue
 *
 * @module StatsHeader
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.3] app/src/APP_DASHBOARD/templates/components/Parts/StatsHeader.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: 'StatsHeader',
  components: {
    StatsRow,
  },
  props: {
    hidePatientDetails: {
      type: Boolean,
      default: () => false,
    },
    bloodPressure: {
      type: String,
      required: false,
    },
    weight: {
      type: [String, Number],
      required: false,
    },
    cholesterolLDL: {
      type: [String, Number],
      required: false,
    },
    cholesterolLDLUnit: {
      type: String,
      required: false,
      default: () => ""
    },
    glucose: {
      type: [String, Number],
      required: false,
    },
    glucoseUnit: {
      type: String,
      required: false,
      default: () => ""
    },
    knowledgeLevelName: {
      type: String,
      required: false,
    },
    behaviourGoals: {
      type: Object,
      default: () => new Inventory(),
    },
    outcomeGoals: {
      type: Object,
      default: () => new Inventory(),
    },
    bmi: {
      type: [String, Number],
      required: false,
    },
    bmiDate: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      showPatientStatsMobile: true,
    };
  },
  computed: {
    ...mapGetters({
      studyId: 'patientSummary/studyId',
    }),
  },
};
</script>

<style lang="scss">
    @import "../../../../scss/colors";

    .c-stats-header__row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 8px 16px;
      margin-left: -12px;
      margin-right: -12px;
      border-bottom: 1px solid #d6dbe4;
    }

    .c-stats-header__patient {
      display: flex;
      align-items: center;
      font-weight: bold;
      white-space: nowrap;
      margin-top: 12px;
      margin-bottom: 12px;
      margin-right: 30px;
    }

    .c-stats-header__stats {
      margin-top: 6px;
      margin-bottom: 6px;
      margin-right: 30px;
      flex-grow: 1;
    }

    .c-stats-header__controls {
      display: flex;
      align-items: center;
    }

    .c-stats-header__patient-icon {
      max-height: 24px;
      margin-right: 10px;
    }

    .c-stats-header__mobile-stats-btn {
      margin-left: 20px;
    }

    // tablet screens
    .v-application.md-up {
      .c-stats-header__row {
        padding: 0 24px 0 30px;
      }
    }

    // desktop/large screens

    // -------------------------------------------------- BEM modifiers ------------------------------------------------
</style>
